import { useSheetContext } from "@/context/sheet";
import { useCreateWorker } from "@/hooks/workers";
import { CreateWorker } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(workers)/workers/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateWorker({
    onSuccess: (worker) => {
      close(() => {
        navigate({
          to: "/workers",
          params: { id: worker.id.toString() },
        });
      });
    },
  });

  const create = async (worker: CreateWorker) => {
    await mutateAsync(worker);
  };

  return <Form onUpsert={create} />;
}
